// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import Typography from "@insite/mobius/Typography";
import React, { FC, ReactNode } from "react";
import { css } from "styled-components";

interface OwnProps {
    editingChildren?: ReactNode | string;
    children?: ReactNode;
}

type Props = OwnProps & HasShellContext;

const CmsEditionMode: FC<Props> = ({ shellContext, children, editingChildren }) => {
    const editChild =
        editingChildren && typeof editingChildren === "string" ? (
            <Typography size={12} color="secondary">
                {editingChildren}
            </Typography>
        ) : (
            editingChildren
        );

    if (shellContext.isEditing) {
        return (
            <StyledWrapper
                css={css`
                    display: flex;
                    flex-direction: column;
                `}
            >
                {shellContext.isEditing ? editChild : null}
                {children}
            </StyledWrapper>
        );
    }

    return <>{children}</>;
};

export default withIsInShell(CmsEditionMode);
